// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__KAPcx","layout_mobile":"App_layout_mobile__nngJi","content":"App_content__uFknh"};